import { Component, OnInit, OnDestroy } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Observable, Subscription } from 'rxjs'
import { filter } from 'rxjs/operators'
import { BreadcrumbService } from '../../../../services/breadcrumb.service'
import { TableData } from '../../models/table-data'
import { BaseNavStateComponent, JmlNavAdapterService, JmlUrlParamService } from '../../../../modules/navigation-state'
import { JmlTitleService } from '../../../../services/jml-title.service'
import { EmptyState } from 'projects/jml-lib/src/lib/models/state/empty-state'

@Component({
  selector: 'jml-lib-select-entity',
  templateUrl: './select-entity.component.html',
  styleUrls: ['./select-entity.component.scss']
})
export class SelectEntityComponent extends BaseNavStateComponent<EmptyState> implements OnInit, OnDestroy {
  tableData: TableData

  token$: Observable<string>
  id$: Observable<string>
  activateFilterViaDoubleClick = true
  routerLink: string[]
  dtoType: string

  subscriptions: Subscription[] = []

  constructor(
    private route: ActivatedRoute, // holds data for active route
    private router: Router, // holds URL of active route
    private jmlNavigationService: JmlUrlParamService,
    private breadcrumbService: BreadcrumbService,
    private titleService: JmlTitleService,

    jmlNav: JmlNavAdapterService
  ) {
    super(jmlNav, route, router)
  }

  ngOnInit() {
    const isRouteComp = true
    // will this component provide a custom identifier?
    const hasCustomComponentIdentifier = false
    // initialize pre-ngOnInit-setting for base class.
    this.initNavStateSettings(isRouteComp, hasCustomComponentIdentifier)
    super.ngOnInit()

    this.subscriptions.push(
      this.route.data.subscribe((data) => {
        this.breadcrumbService.setItems([{ label: data.displayName }])
        this.dtoType = data.entityType
        this.tableData = new TableData(data.entityType)
        this.titleService.setAppTitle(data.displayName)
      })
    )
    this.token$ = this.jmlNavigationService.readToken$(this.route).pipe(filter((token) => !!token))
    this.id$ = this.jmlNavigationService.readIdFromQueryParams$(this.route).pipe(filter((id) => !!id))
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe())
    super.ngOnDestroy()
  }

  // generateLink(selectedEntry: any[]) {
  //   if (selectedEntry) { this.routerLink = ['/' + this.router.url, selectedEntry['id']]; }
  // }
}
